let policyPromise = null;
const loadPolicy = ()=>{
    if (policyPromise == null) {
        policyPromise = import('anchor-password-policy');
    }
    return policyPromise;
};
export const prefetchPasswordPolicy = ()=>{
    void loadPolicy();
};
export const getPasswordScoreAsync = async (password, userInputs)=>(await loadPolicy()).getPasswordScore(password, userInputs);
export const validatePasswordStrengthAsync = async (password, userInputs)=>(await loadPolicy()).validatePasswordStrength(password, userInputs);
